import React, { useState } from 'react';
import { ResultsData, ResultsRow } from 'components/styled-components';
import { Button, Tooltip, Intent } from '@blueprintjs/core';
import { IconNames } from '@blueprintjs/icons';
import styled from 'styled-components';
import { DialogWrapper } from 'components/DialogWrapper';
import {
  reactivateEAUser,
  deactivateEAUser,
  regenerateEAUserPassword,
} from 'api/external-api';
import { AppToaster } from 'components/AppToaster';
import { shouldBold } from 'utils/functions';

const Row = ({ user, fetchUsers, searchQuery }) => {
  const [isOpen, toggleOpen] = useState(false);
  const [isSubmitting, toggleSubmitting] = useState(false);
  const handleClose = () => {
    toggleOpen(false);
  };
  const handleRegenerate = () => {
    toggleSubmitting(true);
    regenerateEAUserPassword(user.clientID)
      .then(res => {
        AppToaster.show({
          intent: Intent.SUCCESS,
          message: res.data.message,
        });
        toggleSubmitting(false);
      })
      .catch(err => {
        AppToaster.show({
          intent: Intent.DANGER,
          message: err.response.data.message,
        });
        toggleSubmitting(false);
      });
    toggleOpen(false);
  };
  const deactivateUser = () => {
    toggleSubmitting(true);
    deactivateEAUser(user.clientID)
      .then(res => {
        AppToaster.show({
          intent: Intent.SUCCESS,
          message: res.data.message,
        });
        toggleSubmitting(false);
        fetchUsers();
      })
      .catch(err => {
        AppToaster.show({
          intent: Intent.DANGER,
          message: err.response.data.message,
        });
        toggleSubmitting(false);
      });
  };

  const reactivateUser = () => {
    toggleSubmitting(true);
    reactivateEAUser(user.clientID)
      .then(res => {
        AppToaster.show({
          intent: Intent.SUCCESS,
          message: res.data.message,
        });
        toggleSubmitting(false);
        fetchUsers();
      })
      .catch(err => {
        AppToaster.show({
          intent: Intent.DANGER,
          message: err.response.data.message,
        });
        toggleSubmitting(false);
      });
  };
  return (
    <ResultsRow>
      <TableDataWithHeaders>
        {shouldBold(user.email, searchQuery)}
      </TableDataWithHeaders>
      <TableDataWithHeaders>{user.statusName}</TableDataWithHeaders>
      <TableDataWithHeaders>{user.creatorUser}</TableDataWithHeaders>
      <TableDataWithHeaders>
        {user.statusName === 'Active' ? (
          <Tooltip content="Deactivate User">
            <Button
              icon={IconNames.BLOCKED_PERSON}
              onClick={deactivateUser}
              text="Deactivate"
              intent={Intent.DANGER}
              style={{ marginRight: 5 }}
              loading={isSubmitting}
            />
          </Tooltip>
        ) : (
          <Tooltip content="Reactivate User">
            <Button
              icon={IconNames.PERSON}
              onClick={reactivateUser}
              text="Reactivate"
              intent={Intent.SUCCESS}
              style={{ marginRight: 5 }}
              loading={isSubmitting}
            />
          </Tooltip>
        )}

        <Tooltip content="Regenerate Password">
          <Button
            icon={IconNames.REFRESH}
            onClick={toggleOpen}
            text="Regenerate Password"
            intent={Intent.PRIMARY}
            loading={isSubmitting}
          />
        </Tooltip>
      </TableDataWithHeaders>
      <DialogWrapper
        isOpen={isOpen}
        onClose={handleClose}
        title="Regenerate Password ?"
        body={`You are about to regenerate the password for ${
          user.email
        }, this will break any sites that currently use this API user. Are you sure you wish to proceed?`}
        confirm="regenerate"
        action={handleRegenerate}
      />
    </ResultsRow>
  );
};

const TableDataWithHeaders = styled(ResultsData)`
  @media only screen and (max-width: 760px),
    (min-width: 761px) and (max-width: 1024px) {
    /*
	Label the data
  */
    &:nth-of-type(1):before {
      content: 'Department Name';
    }
    &:nth-of-type(2):before {
      content: 'Department Description';
    }
    &:nth-of-type(3):before {
      content: 'Created By';
    }
    &:nth-of-type(4):before {
      content: 'Actions';
    }
  }
`;

export default Row;
